"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCommitmentSignature = void 0;
function GetCommitmentSignature(transactionSignature, ephemeralConnection) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var txSchedulingSgn, scheduledCommitSgn, latestBlockhash, txCommitInfo, commitSignature;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, ephemeralConnection.getTransaction(transactionSignature, { maxSupportedTransactionVersion: 0 })];
                case 1:
                    txSchedulingSgn = _c.sent();
                    if ((txSchedulingSgn === null || txSchedulingSgn === void 0 ? void 0 : txSchedulingSgn.meta) == null) {
                        throw new Error("Transaction not found or meta is null");
                    }
                    scheduledCommitSgn = parseScheduleCommitsLogsMessage((_a = txSchedulingSgn.meta.logMessages) !== null && _a !== void 0 ? _a : []);
                    if (scheduledCommitSgn == null) {
                        throw new Error("ScheduledCommitSent signature not found");
                    }
                    return [4, ephemeralConnection.getLatestBlockhash()];
                case 2:
                    latestBlockhash = _c.sent();
                    return [4, ephemeralConnection.confirmTransaction(__assign({ signature: scheduledCommitSgn }, latestBlockhash))];
                case 3:
                    _c.sent();
                    return [4, ephemeralConnection.getTransaction(scheduledCommitSgn, { maxSupportedTransactionVersion: 0 })];
                case 4:
                    txCommitInfo = _c.sent();
                    if ((txCommitInfo === null || txCommitInfo === void 0 ? void 0 : txCommitInfo.meta) == null) {
                        throw new Error("Transaction not found or meta is null");
                    }
                    commitSignature = parseCommitsLogsMessage((_b = txCommitInfo.meta.logMessages) !== null && _b !== void 0 ? _b : []);
                    if (commitSignature == null) {
                        throw new Error("Unable to find Commitment signature");
                    }
                    return [2, commitSignature];
            }
        });
    });
}
exports.GetCommitmentSignature = GetCommitmentSignature;
function parseScheduleCommitsLogsMessage(logMessages) {
    for (var _i = 0, logMessages_1 = logMessages; _i < logMessages_1.length; _i++) {
        var message = logMessages_1[_i];
        var signaturePrefix = "ScheduledCommitSent signature: ";
        if (message.includes(signaturePrefix)) {
            return message.split(signaturePrefix)[1];
        }
    }
    return null;
}
function parseCommitsLogsMessage(logMessages) {
    for (var _i = 0, logMessages_2 = logMessages; _i < logMessages_2.length; _i++) {
        var message = logMessages_2[_i];
        var signaturePrefix = "ScheduledCommitSent signature[0]: ";
        if (message.includes(signaturePrefix)) {
            return message.split(signaturePrefix)[1];
        }
    }
    return null;
}
//# sourceMappingURL=utils.js.map